import { ColorVariantsList } from 'components/Pages/ProductDetail/ColorVariants/ColorVariantsList/ColorVariantsList';
import { ColorVariantsSlider } from 'components/Pages/ProductDetail/ColorVariants/ColorVariantsSlider/ColorVariantsSlider';
import { useMediaMin } from 'hooks/ui/useMediaMin';
import useTranslation from 'next-translate/useTranslation';
import { ColorVariantType } from 'types/product';

type Props = {
    colorVariants: ColorVariantType[];
    currentVariantUuid: string;
};

export const ColorVariants: FC<Props> = ({ colorVariants, currentVariantUuid }) => {
    const { t } = useTranslation();

    const isDesktop = useMediaMin('vl');

    return (
        <>
            <div className="mb-1 text-body font-bold leading-6">{t('Choose color variant')}</div>
            {isDesktop ? (
                <ColorVariantsList colorVariants={colorVariants} currentVariantUuid={currentVariantUuid} />
            ) : (
                <ColorVariantsSlider colorVariants={colorVariants} currentVariantUuid={currentVariantUuid} />
            )}
        </>
    );
};
